





















































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {
  GeceKosusuOrtamListesi,
  KosuOzet,
  KosuDurum,
  KosuYetenekleri,
  TenantAramaSonucu,
  TenantAtlanmaNedeni,
  formatDateTime,
  geceKosusuOrtamlari,
  kosuDurumBilgisi,
  ortamBul,
  sureMetni,
  yuzde
} from "@/entity/GeceKosusuEntity";

/** Yeni koşu diyaloğunun form alanları. */
class YeniKosuFormu {
  tenant: string = "";
  takip: string = "";
  klasik: boolean = false;
  /** R3: ileri tarihli test tarihi ("YYYY-MM-DD"); yalnız yetenekler.ileri_tarih_test açıkken kullanılabilir. */
  hesapTarihi: string | null = null;
}

/** R5: tenant arama alanının olabileceği durumlar. */
type TenantAramaDurumu = "bos" | "araniyor" | "bulundu" | "bulunamadi" | "gecersiz";

/** Basit RFC 4122 UUID biçimi — sunucudaki `uuid` doğrulama kuralıyla aynı esneklikte. */
const UUID_DESENI = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

@Component
export default class GeceKosusu extends Vue {
  /* ---------------- liste durumu ---------------- */
  kosular: KosuOzet[] = [];
  toplamKosu: number = 0;
  yukleniyor: boolean = false;
  /** Son yükleme başarısız olduysa sunucu/ağ mesajı; başarılı yüklemede boşaltılır. */
  yuklemeHatasi: string = "";
  // itemsPerPage tohumlanmalı: Vuetify kütüphanesinin varsayılanı 10, sözleşmedeki
  // varsayılan (per_page=20) ile uyuşmuyor.
  secenekler: any = {page: 1, itemsPerPage: 20};
  footerSecenekleri: any = {"items-per-page-options": [10, 20, 50]};

  /* ---------------- ortam ve yetenekler ---------------- */
  /** Derleme ayarından gelen ortam listesi (bkz. geceKosusuOrtamlari). */
  ortamListesi: GeceKosusuOrtamListesi = {ortamlar: [], yapilandirildi: false};
  seciliOrtam: string = "";
  /** Son başarılı liste yanıtındaki yetenekler; eski API'lerde null kalır. */
  yetenekler: KosuYetenekleri | null = null;

  /** Aynı anda birden çok istek uçarsa geç dönen bayat yanıt yenisini ezmesin. */
  private listeSirasi: number = 0;

  headers = [
    {text: "Tarih", value: "hesap_tarihi", sortable: false, width: 110},
    {text: "Başladı", value: "baslangic_at", sortable: false, width: 150},
    {text: "Başlatan", value: "baslatan", sortable: false},
    {text: "Durum", value: "durum", sortable: false},
    {text: "Kapsam", value: "kapsam", sortable: false},
    {text: "İlerleme", value: "ilerleme", sortable: false, width: 220},
    {text: "Hata", value: "hatali_tenant", sortable: false, align: "center", width: 90},
    {text: "Süre", value: "gecen_saniye", sortable: false, width: 110},
    {text: "", value: "islem", sortable: false, align: "end", width: 100}
  ];

  /* ---------------- yeni koşu diyaloğu ---------------- */
  yeniKosuDialog: boolean = false;
  yeniKosuForm: YeniKosuFormu = new YeniKosuFormu();
  tumBurolarOnay: boolean = false;
  tetikleniyor: boolean = false;
  /** R3: ileri tarihli test tarih seçici açık mı. */
  hesapTarihiMenu: boolean = false;

  /* ---------------- R5: tek büro arama (yeni koşu diyaloğu) ---------------- */
  tenantAramaDurumu: TenantAramaDurumu = "bos";
  tenantAramaSonucu: TenantAramaSonucu | null = null;
  private tenantAramaGecikmesi: any = null;
  /** Uçuştaki tenant arama isteğini bayatlatmak için artan sıra numarası. */
  private tenantAramaSirasi: number = 0;

  /* ---------------- hesaplananlar ---------------- */

  /** Seçili ortamın API kökü (sonunda "/"). Liste kurulmadan önce panelin kendi API'si. */
  get seciliApiUrl(): string {
    if (this.ortamListesi.ortamlar.length === 0) {
      return this.$store.state.icwApiUrl;
    }
    return ortamBul(this.ortamListesi, this.seciliOrtam).apiUrl;
  }

  /** Sunucu okuma tabanı: {seçili API}admin/gece-kosusu (sondaki "/" yok). */
  get tabanUrl(): string {
    return this.seciliApiUrl + "admin/gece-kosusu";
  }

  /** Detaya ve geri dönüşe taşınan sorgu. Seçici yoksa adres çubuğunu kirletmez. */
  get ortamSorgusu(): { [anahtar: string]: string } {
    return this.ortamListesi.yapilandirildi ? {ortam: this.seciliOrtam} : {};
  }

  /** Listede çalışıyor/beklemede/durduruluyor bir koşu varsa "Yeni Koşu Başlat" kilitlenir. */
  get calisanKosuVar(): boolean {
    return this.kosular.some(k =>
        k.durum === "calisiyor" || k.durum === "beklemede" || k.durum === "durduruluyor");
  }

  /**
   * Başlat düğmesi kapalıysa nedeni, açıksa boş metin. Yetenek alanı yalnız
   * sunucu gerçekten "kapalı" dediğinde düğmeyi kapatır; alanı hiç döndürmeyen
   * eski bir API'de bugünkü davranış korunur.
   */
  get baslatKilidi(): string {
    if (this.yetenekler && !this.yetenekler.manuel_tetikleme) {
      return "Bu ortamda panelden koşu başlatma kapalı; yalnız izleme yapılabilir.";
    }
    if (this.calisanKosuVar) {
      return "Zaten çalışan bir koşu var";
    }
    return "";
  }

  /** İkisi de boşsa (büro + takip) tam koşu anlamına gelir — ekstra onay ister. */
  get tumBurolarKapsaminda(): boolean {
    return this.yeniKosuForm.tenant.trim() === "" && this.yeniKosuForm.takip.trim() === "";
  }

  /**
   * Yarının tarihi ("YYYY-MM-DD") — ileri tarihli test seçicisinde alt sınır.
   * YÖNTEM (getter DEĞİL): reaktif olmayan bağımlılıkla (yalnız `new Date()`)
   * vue-class-component bunu sonsuza dek önbelleğe alınan bir computed'e
   * çevirirdi — sekme gece yarısını aşarak açık kalırsa alt sınır donuk
   * kalırdı (bkz. GeceKosusuDetay.vue::bugununTarihi ile aynı sorun/çözüm).
   */
  yarininTarihi(): string {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")
        + "-" + String(d.getDate()).padStart(2, "0");
  }

  /** R3: tarih girildiyse büro alanı boş olamaz — doluysa engel metni, değilse boş. */
  get ileriTarihEngelMetni(): string {
    if (this.yeniKosuForm.hesapTarihi && this.yeniKosuForm.tenant.trim() === "") {
      return "İleri tarihli hesap yalnız tek büro için kullanılabilir.";
    }
    return "";
  }

  get yeniKosuGonderilebilir(): boolean {
    if (this.tetikleniyor) {
      return false;
    }
    if (this.ileriTarihEngelMetni !== "") {
      return false;
    }
    const tenantGirili = this.yeniKosuForm.tenant.trim() !== "";
    if (tenantGirili && this.yetenekler && this.yetenekler.tenant_arama
        && this.tenantAramaDurumu !== "bulundu") {
      return false;
    }
    if (this.tumBurolarKapsaminda) {
      return this.tumBurolarOnay;
    }
    return true;
  }

  /* ---------------- yaşam döngüsü ---------------- */

  created() {
    // Yalnız ortam listesi kurulur. İlk VERİ yüklemesi burada yapılmaz (aşağıdaki not).
    this.ortamListesi = geceKosusuOrtamlari(this.$store.state.icwApiUrl);
    const istenen = typeof this.$route.query.ortam === "string" ? this.$route.query.ortam : "";
    this.seciliOrtam = ortamBul(this.ortamListesi, istenen).anahtar;
  }

  /* ---------------- veri çekme ---------------- */

  @Watch("secenekler", {deep: true})
  onSecenekChange() {
    this.kosulariYukle();
  }

  // İlk yükleme created()'da bilerek yapılmıyor: Vuetify v-data-table, options.sync
  // ile bağlanan secenekler'i ilk render'da bir kez kendiliğinden tetikler (bkz.
  // TenantHavuzu.vue'daki aynı emsal) — ilk yükleme @Watch("secenekler") üzerinden
  // gelir; burada tekrar çağırmak çift istek atardı.

  @Watch("seciliOrtam")
  onOrtamDegisti(yeni: string, eski: string) {
    if (!eski || yeni === eski) {
      return; // created() içindeki ilk atama; ilk yüklemeyi secenekler izleyicisi yapar
    }
    this.$router.replace({query: {...this.$route.query, ortam: yeni}}).catch(() => {});
    this.kosular = [];
    this.toplamKosu = 0;
    this.yetenekler = null;
    if (this.secenekler.page !== 1) {
      this.secenekler = {...this.secenekler, page: 1}; // izleyici yeniden yükler
    } else {
      this.kosulariYukle();
    }
  }

  async kosulariYukle(): Promise<void> {
    const sira = ++this.listeSirasi;
    this.yukleniyor = true;
    try {
      const s = this.secenekler;
      const params = {
        page: s.page || 1,
        per_page: s.itemsPerPage && s.itemsPerPage > 0 ? s.itemsPerPage : 20
      };
      const yanit = await this.$http.get(this.tabanUrl, {params});
      if (sira !== this.listeSirasi) {
        return; // bayat yanıt: daha yenisi geldi
      }
      const govde = yanit.data || {};
      this.kosular = Array.isArray(govde.data) ? govde.data : [];
      this.toplamKosu = govde.total || this.kosular.length;
      this.yetenekler = govde.yetenekler && typeof govde.yetenekler === "object" ? govde.yetenekler : null;
      this.yuklemeHatasi = "";
    } catch (e) {
      if (sira !== this.listeSirasi) {
        return;
      }
      this.kosular = [];
      this.toplamKosu = 0;
      this.yuklemeHatasi = this.hataMesaji(e, {
        401: "Bu sayfayı görüntüleme yetkiniz yok.",
        403: "Bu sayfayı görüntüleme yetkiniz yok."
      });
      this.$toast.error(this.yuklemeHatasi);
    } finally {
      if (sira === this.listeSirasi) {
        this.yukleniyor = false;
      }
    }
  }

  /* ---------------- görüntüleme yardımcıları ---------------- */

  otomatikMi(item: KosuOzet): boolean {
    return item.tetikleyen_tip === "cron";
  }

  durumMeta(durum: KosuDurum) {
    return kosuDurumBilgisi(durum);
  }

  yuzdeHesapla(pay: number, payda: number): number {
    return yuzde(pay, payda);
  }

  sure(saniye: number | null): string {
    return sureMetni(saniye);
  }

  kapsamMetni(item: KosuOzet): string {
    if (item.kapsam === "tum") {
      return "Tüm bürolar";
    }
    if (item.kapsam === "tenant") {
      return "Tek büro";
    }
    if (item.kapsam === "takip") {
      return "Seçili takipler";
    }
    return item.kapsam;
  }

  /**
   * hesap_tarihi sunucudan saf YYYY-MM-DD olarak gelir. Date() üzerinden
   * geçirip toLocaleString ile biçimlemek saat dilimi kaymasına açık olduğu
   * için burada basit string bölme kullanılır.
   */
  tarihGoster(hesapTarihi: string | null): string {
    if (!hesapTarihi) {
      return "-";
    }
    const parcalar = hesapTarihi.split("-");
    if (parcalar.length !== 3) {
      return hesapTarihi;
    }
    return parcalar[2] + "." + parcalar[1] + "." + parcalar[0];
  }

  /** Koşunun fiilen başladığı an (ISO); GeceKosusuEntity'nin re-export ettiği formatDateTime kullanılır. */
  basladiGoster(baslangicAt: string | null): string {
    return baslangicAt ? formatDateTime(baslangicAt) : "—";
  }

  detayaGit(item: KosuOzet) {
    this.$router.push({path: "/icraproWeb/gece-kosusu/" + item.id, query: this.ortamSorgusu});
  }

  /* ---------------- yeni koşu diyaloğu ---------------- */

  yeniKosuAc() {
    this.yeniKosuForm = new YeniKosuFormu();
    this.tumBurolarOnay = false;
    this.hesapTarihiMenu = false;
    clearTimeout(this.tenantAramaGecikmesi);
    ++this.tenantAramaSirasi; // uçuştaki eski aramayı bayatlat
    this.tenantAramaDurumu = "bos";
    this.tenantAramaSonucu = null;
    this.yeniKosuDialog = true;
  }

  yeniKosuKapat() {
    this.yeniKosuDialog = false;
  }

  /**
   * R5: büro alanı değiştikçe (500 ms geciktirilmiş) tenant id arar —
   * TenantHavuzu.vue'daki filtre arama gecikmesiyle aynı teknik
   * (clearTimeout/setTimeout, bkz. o dosyadaki @Watch("filtre.q")).
   * Önceki sonuç HER değişiklikte SENKRON temizlenir ki eski bürunun adı
   * yeni girilen id'nin üstünde asılı kalmasın.
   */
  @Watch("yeniKosuForm.tenant")
  onTenantDegisti(yeni: string) {
    clearTimeout(this.tenantAramaGecikmesi);
    ++this.tenantAramaSirasi; // uçuştaki eski isteği bayatlat
    this.tenantAramaDurumu = "bos";
    this.tenantAramaSonucu = null;

    if (!this.yetenekler || !this.yetenekler.tenant_arama) {
      return;
    }
    const deger = (yeni || "").trim();
    if (deger === "") {
      return;
    }
    if (!UUID_DESENI.test(deger)) {
      this.tenantAramaDurumu = "gecersiz";
      return;
    }
    this.tenantAramaGecikmesi = setTimeout(() => this.tenantAra(deger), 500);
  }

  private async tenantAra(tenantId: string): Promise<void> {
    const sira = ++this.tenantAramaSirasi;
    this.tenantAramaDurumu = "araniyor";
    try {
      const yanit = await this.$http.get(this.tabanUrl + "/panel/tenant/" + tenantId);
      if (sira !== this.tenantAramaSirasi) {
        return; // bayat yanıt: alan üzerinde daha yeni bir arama var
      }
      const veri = yanit.data && yanit.data.data ? yanit.data.data : null;
      if (veri) {
        this.tenantAramaSonucu = veri as TenantAramaSonucu;
        this.tenantAramaDurumu = "bulundu";
      } else {
        this.tenantAramaDurumu = "bulunamadi";
      }
    } catch (e) {
      if (sira !== this.tenantAramaSirasi) {
        return;
      }
      const durum = e && e.response ? e.response.status : 0;
      if (durum === 404) {
        this.tenantAramaDurumu = "bulunamadi";
      } else if (durum === 422) {
        this.tenantAramaDurumu = "gecersiz";
      } else {
        // Ağ/sunucu hatası: arama sonucu belirsiz kalsın, kullanıcı engellenmesin —
        // tetikle() ucu göndermede kendi doğrulamasını zaten tekrar yapar.
        this.tenantAramaDurumu = "bos";
      }
    }
  }

  tenantUyariMetni(uyari: TenantAtlanmaNedeni): string {
    if (uyari === "lisans_yok") {
      return "Aktif ICW lisansı yok, koşuda atlanır";
    }
    if (uyari === "db_yok") {
      return "Veritabanı yok, koşuda atlanır";
    }
    return "";
  }

  private takipListesiCoz(): number[] {
    return this.yeniKosuForm.takip
        .split(",")
        .map(parca => parca.trim())
        .filter(parca => parca !== "")
        .map(parca => Number(parca))
        .filter(sayi => !isNaN(sayi));
  }

  async yeniKosuGonder(): Promise<void> {
    if (!this.yeniKosuGonderilebilir) {
      return;
    }
    this.tetikleniyor = true;
    try {
      const govde: any = {};
      const tenant = this.yeniKosuForm.tenant.trim();
      if (tenant) {
        govde.tenant = tenant;
      }
      const takipListesi = this.takipListesiCoz();
      if (takipListesi.length > 0) {
        govde.takip = takipListesi;
      }
      if (this.yeniKosuForm.klasik) {
        govde.klasik = true;
      }
      if (this.yeniKosuForm.hesapTarihi) {
        govde.hesap_tarihi = this.yeniKosuForm.hesapTarihi;
      }

      const yanit = await this.$http.post(this.tabanUrl + "/panel/tetikle", govde);
      const veri = (yanit.data && yanit.data.data) || {};
      // Kuyruk modunda API süreç başlatmaz; koşucu sunucusundaki toplayıcı
      // satırı dakikada bir alır. Kullanıcı "başladı" sanıp beklemesin.
      this.$toast.success(veri.tetikleme_modu === "kuyruk"
          ? "Koşu sıraya alındı; koşucu sunucusu bir dakika içinde başlatacak."
          : "Koşu başlatıldı.");
      this.yeniKosuDialog = false;
      if (veri.kosu_id) {
        this.$router.push({path: "/icraproWeb/gece-kosusu/" + veri.kosu_id, query: this.ortamSorgusu});
      } else {
        this.kosulariYukle();
      }
    } catch (e) {
      this.$toast.error(this.hataMesaji(e, {
        409: "Zaten çalışan bir koşu var.",
        422: "Girilen bilgiler geçersiz veya bu saatte tam koşu başlatılamıyor (gece penceresi kısıtı).",
        503: "Bu özellik şu anda kapalı.",
        401: "Bu işlem için yetkiniz yok.",
        403: "Bu işlem için yetkiniz yok."
      }));
    } finally {
      this.tetikleniyor = false;
    }
  }

  /** Sunucunun kendi mesajını olduğu gibi gösterir; kendi metnini uydurmaz. */
  private hataMesaji(e: any, ekVarsayilanlar?: { [durum: number]: string }): string {
    const yanit = e && e.response;
    if (!yanit) {
      return "Sunucuya ulaşılamadı.";
    }
    const govde = yanit.data || {};
    if (govde.message) {
      return govde.message;
    }
    if (ekVarsayilanlar && ekVarsayilanlar[yanit.status]) {
      return ekVarsayilanlar[yanit.status];
    }
    return "İstek başarısız (HTTP " + yanit.status + ").";
  }

  beforeDestroy() {
    clearTimeout(this.tenantAramaGecikmesi);
  }
}
